import { gql } from '@apollo/client';

export const CANCEL_ALL_CAMPAIGN_MESSAGES = gql`
  mutation CancelAllCampaignMessages($campaignId: ID!) {
    cancelAllCampaignMessages(input: { campaignId: $campaignId }) {
      count
      errors
    }
  }
`; 